import { action, makeObservable, observable, runInAction } from 'mobx';
import { ICompositeProductApi } from '@canvas-logic/clp-sdk';

import { createAttributeValue, hasAttributeValue } from '@canvas-logic/clp-domain';

import React from 'react';
import { IUICfgAttributeText } from '@canvas-logic/clp-api-types';
import { AttributeCfgUIElementStateBase } from './AttributeCfgUIElementStateBase';
import { TextAttributeCfgUIElement } from '@/UiBuilder/elements/TextAttributeCfgUIElement/TextAttributeCfgUIElement';

let id = 0;

export class TextAttributeCfgUIElementState extends AttributeCfgUIElementStateBase<IUICfgAttributeText> {
  public id = 'text-view-state-' + ++id;

  value: string | null = null;
  availableValues: string[] = [];
  loading = false;

  constructor(public readonly api: ICompositeProductApi, element: IUICfgAttributeText) {
    super(api, element);
    // this.visible = this.api.isAvailable(this.componentKey);
    this.updateCurrent();
    if (this.value) {
      this.availableValues = [this.value];
    }

    makeObservable(this, {
      loading: observable,
      availableValues: observable,
      value: observable,
      update: action.bound,
      loadAvailableValues: action.bound,
      setValue: action.bound,
    });

    this.update().then(() => this.loadAvailableValues());
  }

  async update() {
    super.update();
    if (this.visible) {
      this.loading = true;
      this.loadAvailableValues();
      runInAction(() => {
        this.loading = false;

        this.updateCurrent();
      });
    }
  }

  async setValue(newValue: string) {
    const attributeValue = createAttributeValue(newValue);
    console.log('setValue', this.componentKey, this.attributeKey, attributeValue);
    await this.api.setAttributeValue(this.componentKey, this.attributeKey, attributeValue);
    await this.update();
    this.handleUpdate();
  }

  private handleUpdate() {
    this.notify({
      event: 'updateDependentAttributes',
      attributes: [],
      target: this,
    });
  }

  private updateCurrent() {
    this.value = this.api.getAttributeValue(this.componentKey, this.attributeKey)?.value;
  }

  async loadAvailableValues() {
    const values = await this.api.loadCompatibleAttributeValues(this.componentKey, this.attributeKey);

    runInAction(() => {
      this.availableValues = [];
      for (const attributeValue of values) {
        if (hasAttributeValue(attributeValue)) {
          if (typeof attributeValue.value !== 'undefined') {
            this.availableValues.push(attributeValue.value);
          }
        }
      }
    });
  }

  render(): React.ReactElement {
    return <TextAttributeCfgUIElement key={this.id} state={this} textData={this.textData} />;
  }
}
